// Generated by pnpm generate:icons from sources.json. Do not edit.
import { createIcon } from '../create-icon';
import SvgPlus from './Plus';
import SvgPlusCircle from './PlusCircle';
import SvgAgreement from './Agreement';
import SvgAiChat from './AiChat';
import SvgWarning from './Warning';
import SvgWarningCircle from './WarningCircle';
import SvgAnalytics from './Analytics';
import SvgApi from './Api';
import SvgArchive from './Archive';
import SvgChevronDown from './ChevronDown';
import SvgChevronLeft from './ChevronLeft';
import SvgArrowLeft from './ArrowLeft';
import SvgChevronRight from './ChevronRight';
import SvgArrowRight from './ArrowRight';
import SvgChevronUp from './ChevronUp';
import SvgArrowUp from './ArrowUp';
import SvgArrowDown from './ArrowDown';
import SvgArrowUpRight from './ArrowUpRight';
import SvgExpand from './Expand';
import SvgCollapse from './Collapse';
import SvgSwapHorizontal from './SwapHorizontal';
import SvgAttachment from './Attachment';
import SvgAudioBook from './AudioBook';
import SvgBank from './Bank';
import SvgBath from './Bath';
import SvgBed from './Bed';
import SvgBlocked from './Blocked';
import SvgBook from './Book';
import SvgBookOpen from './BookOpen';
import SvgBookmark from './Bookmark';
import SvgBot from './Bot';
import SvgBriefcase from './Briefcase';
import SvgBrowser from './Browser';
import SvgChat from './Chat';
import SvgBuilding from './Building';
import SvgCalculator from './Calculator';
import SvgCalendar from './Calendar';
import SvgCalendarCheck from './CalendarCheck';
import SvgCalendarMinus from './CalendarMinus';
import SvgCalendarClose from './CalendarClose';
import SvgCalendarSync from './CalendarSync';
import SvgCalendarUser from './CalendarUser';
import SvgMinusCircle from './MinusCircle';
import SvgClose from './Close';
import SvgCloseCircle from './CloseCircle';
import SvgCashier from './Cashier';
import SvgChart from './Chart';
import SvgChartColumn from './ChartColumn';
import SvgChartLine from './ChartLine';
import SvgChatAdd from './ChatAdd';
import SvgCheckList from './CheckList';
import SvgCheck from './Check';
import SvgCheckBadge from './CheckBadge';
import SvgCheckCircle from './CheckCircle';
import SvgCheckSquare from './CheckSquare';
import SvgCircle from './Circle';
import SvgCity from './City';
import SvgClipboard from './Clipboard';
import SvgClipboardClock from './ClipboardClock';
import SvgClock from './Clock';
import SvgCloud from './Cloud';
import SvgCloudCheck from './CloudCheck';
import SvgCloudServer from './CloudServer';
import SvgCloudUpload from './CloudUpload';
import SvgCoins from './Coins';
import SvgCommand from './Command';
import SvgCompass from './Compass';
import SvgComputer from './Computer';
import SvgComputerDollar from './ComputerDollar';
import SvgCopy from './Copy';
import SvgCreditCard from './CreditCard';
import SvgCreditCardEdit from './CreditCardEdit';
import SvgMagicSelection from './MagicSelection';
import SvgDashboard from './Dashboard';
import SvgDatabase from './Database';
import SvgDatabaseImport from './DatabaseImport';
import SvgDelete from './Delete';
import SvgDiscount from './Discount';
import SvgDivide from './Divide';
import SvgDocumentCheck from './DocumentCheck';
import SvgDog from './Dog';
import SvgDollar from './Dollar';
import SvgDollarCircle from './DollarCircle';
import SvgDollarSquare from './DollarSquare';
import SvgDoor from './Door';
import SvgDoorOpen from './DoorOpen';
import SvgDownload from './Download';
import SvgDragVertical from './DragVertical';
import SvgDroplet from './Droplet';
import SvgEdit from './Edit';
import SvgEye from './Eye';
import SvgDocument from './Document';
import SvgDocumentAdd from './DocumentAdd';
import SvgDocumentClock from './DocumentClock';
import SvgDocumentDownload from './DocumentDownload';
import SvgDocumentEdit from './DocumentEdit';
import SvgDocumentRemove from './DocumentRemove';
import SvgDocumentUpload from './DocumentUpload';
import SvgFilter from './Filter';
import SvgFilterClear from './FilterClear';
import SvgFingerprint from './Fingerprint';
import SvgFlash from './Flash';
import SvgSave from './Save';
import SvgFolder from './Folder';
import SvgFolderAdd from './FolderAdd';
import SvgFolderBlocked from './FolderBlocked';
import SvgFolderLibrary from './FolderLibrary';
import SvgFolderLock from './FolderLock';
import SvgFolderOpen from './FolderOpen';
import SvgFolderTransfer from './FolderTransfer';
import SvgGift from './Gift';
import SvgGlobe from './Globe';
import SvgGrid from './Grid';
import SvgHashtag from './Hashtag';
import SvgHelpCircle from './HelpCircle';
import SvgHome from './Home';
import SvgIdea from './Idea';
import SvgImage from './Image';
import SvgImageMissing from './ImageMissing';
import SvgInbox from './Inbox';
import SvgInfoCircle from './InfoCircle';
import SvgInvoice from './Invoice';
import SvgKey from './Key';
import SvgLayersAdd from './LayersAdd';
import SvgListBullet from './ListBullet';
import SvgLegalHammer from './LegalHammer';
import SvgLink from './Link';
import SvgExternalLink from './ExternalLink';
import SvgListNumber from './ListNumber';
import SvgList from './List';
import SvgLoading from './Loading';
import SvgLocation from './Location';
import SvgLock from './Lock';
import SvgLogout from './Logout';
import SvgMagicWand from './MagicWand';
import SvgMail from './Mail';
import SvgMailCheck from './MailCheck';
import SvgMailClose from './MailClose';
import SvgMailAccount from './MailAccount';
import SvgMailEdit from './MailEdit';
import SvgMailSend from './MailSend';
import SvgMap from './Map';
import SvgMegaphone from './Megaphone';
import SvgMenu from './Menu';
import SvgChatOff from './ChatOff';
import SvgChatText from './ChatText';
import SvgChatQuestion from './ChatQuestion';
import SvgMinus from './Minus';
import SvgMobileCode from './MobileCode';
import SvgMoney from './Money';
import SvgMoneyBag from './MoneyBag';
import SvgMoneyExchange from './MoneyExchange';
import SvgMoneyReceive from './MoneyReceive';
import SvgSavings from './Savings';
import SvgMoneySend from './MoneySend';
import SvgMoneySendCircle from './MoneySendCircle';
import SvgMoon from './Moon';
import SvgMoreHorizontal from './MoreHorizontal';
import SvgMoreHorizontalCircle from './MoreHorizontalCircle';
import SvgMoreVertical from './MoreVertical';
import SvgMusicNote from './MusicNote';
import SvgNote from './Note';
import SvgNotification from './Notification';
import SvgNotificationOff from './NotificationOff';
import SvgPackage from './Package';
import SvgPalette from './Palette';
import SvgPaintBrush from './PaintBrush';
import SvgParking from './Parking';
import SvgPauseCircle from './PauseCircle';
import SvgPayment from './Payment';
import SvgDocumentPdf from './DocumentPdf';
import SvgPushpin from './Pushpin';
import SvgPlay from './Play';
import SvgPlayCircle from './PlayCircle';
import SvgPlug from './Plug';
import SvgPrinter from './Printer';
import SvgSignature from './Signature';
import SvgRedo from './Redo';
import SvgRefresh from './Refresh';
import SvgWrench from './Wrench';
import SvgRocket from './Rocket';
import SvgRuler from './Ruler';
import SvgSafe from './Safe';
import SvgScissors from './Scissors';
import SvgSearch from './Search';
import SvgSearchList from './SearchList';
import SvgZoomOut from './ZoomOut';
import SvgShieldCheck from './ShieldCheck';
import SvgPassword from './Password';
import SvgSend from './Send';
import SvgSettings from './Settings';
import SvgShare from './Share';
import SvgShield from './Shield';
import SvgShieldWarning from './ShieldWarning';
import SvgShieldAdd from './ShieldAdd';
import SvgShieldBlocked from './ShieldBlocked';
import SvgShieldUser from './ShieldUser';
import SvgSidebarLeft from './SidebarLeft';
import SvgSort from './Sort';
import SvgSortDown from './SortDown';
import SvgSortUp from './SortUp';
import SvgSparkles from './Sparkles';
import SvgLockSquare from './LockSquare';
import SvgStar from './Star';
import SvgStop from './Stop';
import SvgStopCircle from './StopCircle';
import SvgStore from './Store';
import SvgStructure from './Structure';
import SvgSun from './Sun';
import SvgTable from './Table';
import SvgTag from './Tag';
import SvgTarget from './Target';
import SvgTaskAdd from './TaskAdd';
import SvgTaskCheck from './TaskCheck';
import SvgTelephone from './Telephone';
import SvgChemistryFlask from './ChemistryFlask';
import SvgTextAlignLeft from './TextAlignLeft';
import SvgTextBold from './TextBold';
import SvgTextItalic from './TextItalic';
import SvgThumbDown from './ThumbDown';
import SvgThumbUp from './ThumbUp';
import SvgCheckDouble from './CheckDouble';
import SvgTools from './Tools';
import SvgDocumentText from './DocumentText';
import SvgUndo from './Undo';
import SvgChevronsUpDown from './ChevronsUpDown';
import SvgUpload from './Upload';
import SvgUser from './User';
import SvgUserAdd from './UserAdd';
import SvgUserBlocked from './UserBlocked';
import SvgUserCheck from './UserCheck';
import SvgUserCircle from './UserCircle';
import SvgUserEdit from './UserEdit';
import SvgUsers from './Users';
import SvgUsersGroup from './UsersGroup';
import SvgUserId from './UserId';
import SvgUserSettings from './UserSettings';
import SvgUserSearch from './UserSearch';
import SvgVideo from './Video';
import SvgEyeOff from './EyeOff';
import SvgVoice from './Voice';
import SvgWallet from './Wallet';
import SvgWebProtection from './WebProtection';
import SvgWebhook from './Webhook';
import SvgDocumentZip from './DocumentZip';
import SvgAcademicCap from './AcademicCap';
import SvgEditSquare from './EditSquare';
import SvgDelivery from './Delivery';
import SvgZoomIn from './ZoomIn';
import SvgVolume from './Volume';
import SvgClap from './Clap';
import SvgChevronsLeft from './ChevronsLeft';
import SvgChevronsRight from './ChevronsRight';
import SvgReceiptSuccess from './ReceiptSuccess';
import SvgVisa from './Visa';
import SvgMastercard from './Mastercard';
import SvgAmex from './Amex';
import SvgDiscover from './Discover';
import SvgQuickbooks from './Quickbooks';
import SvgZillow from './Zillow';
import SvgAgreementFilled from './AgreementFilled';
import SvgAnalyticsFilled from './AnalyticsFilled';
import SvgApiFilled from './ApiFilled';
import SvgBriefcaseFilled from './BriefcaseFilled';
import SvgBuildingFilled from './BuildingFilled';
import SvgCalendarFilled from './CalendarFilled';
import SvgChartLineFilled from './ChartLineFilled';
import SvgCheckSquareFilled from './CheckSquareFilled';
import SvgCityFilled from './CityFilled';
import SvgClipboardClockFilled from './ClipboardClockFilled';
import SvgClockFilled from './ClockFilled';
import SvgComputerDollarFilled from './ComputerDollarFilled';
import SvgCreditCardFilled from './CreditCardFilled';
import SvgDashboardFilled from './DashboardFilled';
import SvgDatabaseImportFilled from './DatabaseImportFilled';
import SvgDocumentFilled from './DocumentFilled';
import SvgDocumentAttachmentFilled from './DocumentAttachmentFilled';
import SvgDocumentEditFilled from './DocumentEditFilled';
import SvgDownloadFilled from './DownloadFilled';
import SvgFingerprintFilled from './FingerprintFilled';
import SvgFolderFilled from './FolderFilled';
import SvgFolderLibraryFilled from './FolderLibraryFilled';
import SvgGlobeFilled from './GlobeFilled';
import SvgHomeFilled from './HomeFilled';
import SvgInboxFilled from './InboxFilled';
import SvgKeyFilled from './KeyFilled';
import SvgMailAccountFilled from './MailAccountFilled';
import SvgMegaphoneFilled from './MegaphoneFilled';
import SvgMoneyFilled from './MoneyFilled';
import SvgMoneyExchangeFilled from './MoneyExchangeFilled';
import SvgNoteFilled from './NoteFilled';
import SvgNotificationFilled from './NotificationFilled';
import SvgPlugFilled from './PlugFilled';
import SvgPushpinFilled from './PushpinFilled';
import SvgReceiptFilled from './ReceiptFilled';
import SvgRefreshFilled from './RefreshFilled';
import SvgSendFilled from './SendFilled';
import SvgSettingsFilled from './SettingsFilled';
import SvgShieldCheckFilled from './ShieldCheckFilled';
import SvgShieldUserFilled from './ShieldUserFilled';
import SvgStarFilled from './StarFilled';
import SvgStopFilled from './StopFilled';
import SvgSwapHorizontalFilled from './SwapHorizontalFilled';
import SvgTableFilled from './TableFilled';
import SvgTargetFilled from './TargetFilled';
import SvgTaskFilled from './TaskFilled';
import SvgUserFilled from './UserFilled';
import SvgUsersFilled from './UsersFilled';
import SvgUsersGroupFilled from './UsersGroupFilled';
import SvgWarningFilled from './WarningFilled';
import SvgWebProtectionFilled from './WebProtectionFilled';
import SvgWrenchFilled from './WrenchFilled';
import SvgHomeBulk from './HomeBulk';
import SvgHomeFun from './HomeFun';
import SvgHomeFunBulk from './HomeFunBulk';
import SvgBoardMenu from './BoardMenu';
import SvgBoardMenuBulk from './BoardMenuBulk';
import SvgPaperCurved from './PaperCurved';
import SvgPaperCurvedBulk from './PaperCurvedBulk';
import SvgCityBulk from './CityBulk';
import SvgBoardPin from './BoardPin';
import SvgBoardPinBulk from './BoardPinBulk';
import SvgClockClockwise from './ClockClockwise';
import SvgDocumentEditBulk from './DocumentEditBulk';
import SvgDocumentAddBulk from './DocumentAddBulk';
import SvgBriefcaseBulk from './BriefcaseBulk';
import SvgRepeat from './Repeat';
import SvgRepeatBulk from './RepeatBulk';
import SvgUserVerify from './UserVerify';
import SvgUserVerifyBulk from './UserVerifyBulk';
import SvgUsersThree from './UsersThree';
import SvgUsersThreeFilled from './UsersThreeFilled';
import SvgTaskBulk from './TaskBulk';
import SvgBoardTasks from './BoardTasks';
import SvgBoardTasksBulk from './BoardTasksBulk';
import SvgCalendarStar from './CalendarStar';
import SvgCalendarQuestion from './CalendarQuestion';
import SvgCalendarAddFlip from './CalendarAddFlip';
import SvgMailBulk from './MailBulk';
import SvgNotificationBulk from './NotificationBulk';
import SvgMailOpen from './MailOpen';
import SvgMailOpenBulk from './MailOpenBulk';
import SvgClockPresentation from './ClockPresentation';
import SvgMailSendBulk from './MailSendBulk';
import SvgMailReceive from './MailReceive';
import SvgMailReceiveBulk from './MailReceiveBulk';
import SvgMailDocument from './MailDocument';
import SvgMailDocumentFilled from './MailDocumentFilled';
import SvgMailAi from './MailAi';
import SvgDollarUp from './DollarUp';
import SvgDollarUpBulk from './DollarUpBulk';
import SvgDocumentBulk from './DocumentBulk';
import SvgCardWallet from './CardWallet';
import SvgCardWalletBulk from './CardWalletBulk';
import SvgBankCardShareMoney from './BankCardShareMoney';
import SvgBankCardShareMoneyBulk from './BankCardShareMoneyBulk';
import SvgCards from './Cards';
import SvgCardsBulk from './CardsBulk';
import SvgSettingsGear from './SettingsGear';
import SvgSettingsGearBulk from './SettingsGearBulk';
import SvgUsersTwo from './UsersTwo';
import SvgUsersTwoFilled from './UsersTwoFilled';
import SvgShieldUserBulk from './ShieldUserBulk';
import SvgUserEditBulk from './UserEditBulk';
import SvgUserSettingsBulk from './UserSettingsBulk';
import SvgFaceIdLock from './FaceIdLock';
import SvgFaceIdLockBulk from './FaceIdLockBulk';
import SvgNetworkEdit from './NetworkEdit';
import SvgClockWorld from './ClockWorld';
import SvgWalletMenu from './WalletMenu';
import SvgWalletMenuBulk from './WalletMenuBulk';
import SvgConnectedCable from './ConnectedCable';
import SvgShieldDone from './ShieldDone';
import SvgShieldDoneBulk from './ShieldDoneBulk';
import SvgApiBulk from './ApiBulk';
import SvgCloudDownload from './CloudDownload';
import SvgCloudDownloadBulk from './CloudDownloadBulk';
import SvgCalendarPercent from './CalendarPercent';
import SvgCashierBulk from './CashierBulk';
import SvgTargetSearch from './TargetSearch';
import SvgTargetSearchBulk from './TargetSearchBulk';
import SvgHomeFunFilled from './HomeFunFilled';
import SvgBoardMenuFilled from './BoardMenuFilled';
import SvgPaperCurvedFilled from './PaperCurvedFilled';
import SvgBoardPinFilled from './BoardPinFilled';
import SvgDocumentAddFilled from './DocumentAddFilled';
import SvgRepeatFilled from './RepeatFilled';
import SvgUserVerifyFilled from './UserVerifyFilled';
import SvgBoardTasksFilled from './BoardTasksFilled';
import SvgMailFilled from './MailFilled';
import SvgMailOpenFilled from './MailOpenFilled';
import SvgMailSendFilled from './MailSendFilled';
import SvgMailReceiveFilled from './MailReceiveFilled';
import SvgDollarUpFilled from './DollarUpFilled';
import SvgCardWalletFilled from './CardWalletFilled';
import SvgBankCardShareMoneyFilled from './BankCardShareMoneyFilled';
import SvgCardsFilled from './CardsFilled';
import SvgUserEditFilled from './UserEditFilled';
import SvgUserSettingsFilled from './UserSettingsFilled';
import SvgFaceIdLockFilled from './FaceIdLockFilled';
import SvgWalletMenuFilled from './WalletMenuFilled';
import SvgShieldDoneFilled from './ShieldDoneFilled';
import SvgCloudDownloadFilled from './CloudDownloadFilled';
import SvgCashierFilled from './CashierFilled';
import SvgTargetSearchFilled from './TargetSearchFilled';
import SvgSettingsGearFilled from './SettingsGearFilled';
import SvgRingtone from './Ringtone';
import SvgSidebarViews from './SidebarViews';
import SvgSidebarPin from './SidebarPin';
import SvgSidebarHistory from './SidebarHistory';
import SvgSidebarHome from './SidebarHome';
import SvgSidebarBuilding from './SidebarBuilding';
import SvgSidebarUnit from './SidebarUnit';
import SvgSidebarPeople from './SidebarPeople';
import SvgSidebarUser from './SidebarUser';
import SvgSidebarUserActive from './SidebarUserActive';
import SvgSidebarUserInactive from './SidebarUserInactive';
import SvgSidebarDocument from './SidebarDocument';
import SvgSidebarAgreement from './SidebarAgreement';
import SvgSidebarCalendar from './SidebarCalendar';
import SvgSidebarTasks from './SidebarTasks';
import SvgSidebarClock from './SidebarClock';
import SvgSidebarInbox from './SidebarInbox';
import SvgSidebarVendor from './SidebarVendor';
import SvgSidebarWork from './SidebarWork';
import SvgSidebarChart from './SidebarChart';
import SvgSidebarWallet from './SidebarWallet';
import SvgSidebarPinFilled from './SidebarPinFilled';
import SvgStarMagicGlow from './StarMagicGlow';
import SvgStarMagicGlowFilled from './StarMagicGlowFilled';
import SvgFullscreen from './Fullscreen';
import SvgFullscreenExit from './FullscreenExit';
import SvgTaskList from './TaskList';
import SvgTablet from './Tablet';
import SvgHistory from './History';
import SvgHomeSearch from './HomeSearch';

export const AcademicCapIcon = /* @__PURE__ */ createIcon(SvgAcademicCap, "academic-cap");
export const AgreementIcon = /* @__PURE__ */ createIcon(SvgAgreement, "agreement");
export const AgreementFilledIcon = /* @__PURE__ */ createIcon(SvgAgreementFilled, "agreement-filled");
export const AiChatIcon = /* @__PURE__ */ createIcon(SvgAiChat, "ai-chat");
export const AiSuggestionIcon = /* @__PURE__ */ createIcon(SvgStarMagicGlow, "ai-suggestion");
export const AiSuggestionFilledIcon = /* @__PURE__ */ createIcon(SvgStarMagicGlowFilled, "ai-suggestion-filled");
export const AmexIcon = /* @__PURE__ */ createIcon(SvgAmex, "amex", { fill: "currentColor" });
export const AnalyticsIcon = /* @__PURE__ */ createIcon(SvgAnalytics, "analytics");
export const AnalyticsFilledIcon = /* @__PURE__ */ createIcon(SvgAnalyticsFilled, "analytics-filled");
export const ApiIcon = /* @__PURE__ */ createIcon(SvgApi, "api");
export const ApiBulkIcon = /* @__PURE__ */ createIcon(SvgApiBulk, "api-bulk");
export const ApiFilledIcon = /* @__PURE__ */ createIcon(SvgApiFilled, "api-filled");
export const ArchiveIcon = /* @__PURE__ */ createIcon(SvgArchive, "archive");
export const ArrowDownIcon = /* @__PURE__ */ createIcon(SvgArrowDown, "arrow-down");
export const ArrowLeftIcon = /* @__PURE__ */ createIcon(SvgArrowLeft, "arrow-left");
export const ArrowRightIcon = /* @__PURE__ */ createIcon(SvgArrowRight, "arrow-right");
export const ArrowUpIcon = /* @__PURE__ */ createIcon(SvgArrowUp, "arrow-up");
export const ArrowUpRightIcon = /* @__PURE__ */ createIcon(SvgArrowUpRight, "arrow-up-right");
export const AttachmentIcon = /* @__PURE__ */ createIcon(SvgAttachment, "attachment");
export const AudioBookIcon = /* @__PURE__ */ createIcon(SvgAudioBook, "audio-book");
export const BankIcon = /* @__PURE__ */ createIcon(SvgBank, "bank");
export const BankCardShareMoneyIcon = /* @__PURE__ */ createIcon(SvgBankCardShareMoney, "bank-card-share-money");
export const BankCardShareMoneyBulkIcon = /* @__PURE__ */ createIcon(SvgBankCardShareMoneyBulk, "bank-card-share-money-bulk");
export const BankCardShareMoneyFilledIcon = /* @__PURE__ */ createIcon(SvgBankCardShareMoneyFilled, "bank-card-share-money-filled");
export const BathIcon = /* @__PURE__ */ createIcon(SvgBath, "bath");
export const BedIcon = /* @__PURE__ */ createIcon(SvgBed, "bed");
export const BlockedIcon = /* @__PURE__ */ createIcon(SvgBlocked, "blocked");
export const BoardMenuIcon = /* @__PURE__ */ createIcon(SvgBoardMenu, "board-menu");
export const BoardMenuBulkIcon = /* @__PURE__ */ createIcon(SvgBoardMenuBulk, "board-menu-bulk");
export const BoardMenuFilledIcon = /* @__PURE__ */ createIcon(SvgBoardMenuFilled, "board-menu-filled");
export const BoardPinIcon = /* @__PURE__ */ createIcon(SvgBoardPin, "board-pin");
export const BoardPinBulkIcon = /* @__PURE__ */ createIcon(SvgBoardPinBulk, "board-pin-bulk");
export const BoardPinFilledIcon = /* @__PURE__ */ createIcon(SvgBoardPinFilled, "board-pin-filled");
export const BoardTasksIcon = /* @__PURE__ */ createIcon(SvgBoardTasks, "board-tasks");
export const BoardTasksBulkIcon = /* @__PURE__ */ createIcon(SvgBoardTasksBulk, "board-tasks-bulk");
export const BoardTasksFilledIcon = /* @__PURE__ */ createIcon(SvgBoardTasksFilled, "board-tasks-filled");
export const BookIcon = /* @__PURE__ */ createIcon(SvgBook, "book");
export const BookOpenIcon = /* @__PURE__ */ createIcon(SvgBookOpen, "book-open");
export const BookmarkIcon = /* @__PURE__ */ createIcon(SvgBookmark, "bookmark");
export const BotIcon = /* @__PURE__ */ createIcon(SvgBot, "bot");
export const BriefcaseIcon = /* @__PURE__ */ createIcon(SvgBriefcase, "briefcase");
export const BriefcaseBulkIcon = /* @__PURE__ */ createIcon(SvgBriefcaseBulk, "briefcase-bulk");
export const BriefcaseFilledIcon = /* @__PURE__ */ createIcon(SvgBriefcaseFilled, "briefcase-filled");
export const BrowserIcon = /* @__PURE__ */ createIcon(SvgBrowser, "browser");
export const BuildingIcon = /* @__PURE__ */ createIcon(SvgBuilding, "building");
export const BuildingFilledIcon = /* @__PURE__ */ createIcon(SvgBuildingFilled, "building-filled");
export const BunkBedIcon = /* @__PURE__ */ createIcon(SvgBed, "bunk-bed");
export const CalculatorIcon = /* @__PURE__ */ createIcon(SvgCalculator, "calculator");
export const CalendarIcon = /* @__PURE__ */ createIcon(SvgCalendar, "calendar");
export const CalendarAddFlipIcon = /* @__PURE__ */ createIcon(SvgCalendarAddFlip, "calendar-add-flip");
export const CalendarCheckIcon = /* @__PURE__ */ createIcon(SvgCalendarCheck, "calendar-check");
export const CalendarCloseIcon = /* @__PURE__ */ createIcon(SvgCalendarClose, "calendar-close");
export const CalendarFilledIcon = /* @__PURE__ */ createIcon(SvgCalendarFilled, "calendar-filled");
export const CalendarMinusIcon = /* @__PURE__ */ createIcon(SvgCalendarMinus, "calendar-minus");
export const CalendarPercentIcon = /* @__PURE__ */ createIcon(SvgCalendarPercent, "calendar-percent");
export const CalendarQuestionIcon = /* @__PURE__ */ createIcon(SvgCalendarQuestion, "calendar-question");
export const CalendarStarIcon = /* @__PURE__ */ createIcon(SvgCalendarStar, "calendar-star");
export const CalendarSyncIcon = /* @__PURE__ */ createIcon(SvgCalendarSync, "calendar-sync");
export const CalendarUserIcon = /* @__PURE__ */ createIcon(SvgCalendarUser, "calendar-user");
export const CardWalletIcon = /* @__PURE__ */ createIcon(SvgCardWallet, "card-wallet");
export const CardWalletBulkIcon = /* @__PURE__ */ createIcon(SvgCardWalletBulk, "card-wallet-bulk");
export const CardWalletFilledIcon = /* @__PURE__ */ createIcon(SvgCardWalletFilled, "card-wallet-filled");
export const CardsIcon = /* @__PURE__ */ createIcon(SvgCards, "cards");
export const CardsBulkIcon = /* @__PURE__ */ createIcon(SvgCardsBulk, "cards-bulk");
export const CardsFilledIcon = /* @__PURE__ */ createIcon(SvgCardsFilled, "cards-filled");
export const CashierIcon = /* @__PURE__ */ createIcon(SvgCashier, "cashier");
export const CashierBulkIcon = /* @__PURE__ */ createIcon(SvgCashierBulk, "cashier-bulk");
export const CashierFilledIcon = /* @__PURE__ */ createIcon(SvgCashierFilled, "cashier-filled");
export const ChartIcon = /* @__PURE__ */ createIcon(SvgChart, "chart");
export const ChartColumnIcon = /* @__PURE__ */ createIcon(SvgChartColumn, "chart-column");
export const ChartLineIcon = /* @__PURE__ */ createIcon(SvgChartLine, "chart-line");
export const ChartLineFilledIcon = /* @__PURE__ */ createIcon(SvgChartLineFilled, "chart-line-filled");
export const ChatIcon = /* @__PURE__ */ createIcon(SvgChat, "chat");
export const ChatAddIcon = /* @__PURE__ */ createIcon(SvgChatAdd, "chat-add");
export const ChatOffIcon = /* @__PURE__ */ createIcon(SvgChatOff, "chat-off");
export const ChatQuestionIcon = /* @__PURE__ */ createIcon(SvgChatQuestion, "chat-question");
export const ChatTextIcon = /* @__PURE__ */ createIcon(SvgChatText, "chat-text");
export const CheckIcon = /* @__PURE__ */ createIcon(SvgCheck, "check");
export const CheckBadgeIcon = /* @__PURE__ */ createIcon(SvgCheckBadge, "check-badge");
export const CheckCircleIcon = /* @__PURE__ */ createIcon(SvgCheckCircle, "check-circle");
export const CheckDoubleIcon = /* @__PURE__ */ createIcon(SvgCheckDouble, "check-double");
export const CheckListIcon = /* @__PURE__ */ createIcon(SvgCheckList, "check-list");
export const CheckSquareIcon = /* @__PURE__ */ createIcon(SvgCheckSquare, "check-square");
export const CheckSquareFilledIcon = /* @__PURE__ */ createIcon(SvgCheckSquareFilled, "check-square-filled");
export const ChemistryFlaskIcon = /* @__PURE__ */ createIcon(SvgChemistryFlask, "chemistry-flask");
export const ChevronDownIcon = /* @__PURE__ */ createIcon(SvgChevronDown, "chevron-down");
export const ChevronLeftIcon = /* @__PURE__ */ createIcon(SvgChevronLeft, "chevron-left");
export const ChevronRightIcon = /* @__PURE__ */ createIcon(SvgChevronRight, "chevron-right");
export const ChevronUpIcon = /* @__PURE__ */ createIcon(SvgChevronUp, "chevron-up");
export const ChevronsLeftIcon = /* @__PURE__ */ createIcon(SvgChevronsLeft, "chevrons-left");
export const ChevronsRightIcon = /* @__PURE__ */ createIcon(SvgChevronsRight, "chevrons-right");
export const ChevronsUpDownIcon = /* @__PURE__ */ createIcon(SvgChevronsUpDown, "chevrons-up-down");
export const CircleIcon = /* @__PURE__ */ createIcon(SvgCircle, "circle");
export const CityIcon = /* @__PURE__ */ createIcon(SvgCity, "city");
export const CityBulkIcon = /* @__PURE__ */ createIcon(SvgCityBulk, "city-bulk");
export const CityFilledIcon = /* @__PURE__ */ createIcon(SvgCityFilled, "city-filled");
export const ClapIcon = /* @__PURE__ */ createIcon(SvgClap, "clap");
export const ClipboardIcon = /* @__PURE__ */ createIcon(SvgClipboard, "clipboard");
export const ClipboardClockIcon = /* @__PURE__ */ createIcon(SvgClipboardClock, "clipboard-clock");
export const ClipboardClockFilledIcon = /* @__PURE__ */ createIcon(SvgClipboardClockFilled, "clipboard-clock-filled");
export const ClockIcon = /* @__PURE__ */ createIcon(SvgClock, "clock");
export const ClockClockwiseIcon = /* @__PURE__ */ createIcon(SvgClockClockwise, "clock-clockwise");
export const ClockFilledIcon = /* @__PURE__ */ createIcon(SvgClockFilled, "clock-filled");
export const ClockPresentationIcon = /* @__PURE__ */ createIcon(SvgClockPresentation, "clock-presentation");
export const ClockWorldIcon = /* @__PURE__ */ createIcon(SvgClockWorld, "clock-world");
export const CloseIcon = /* @__PURE__ */ createIcon(SvgClose, "close");
export const CloseCircleIcon = /* @__PURE__ */ createIcon(SvgCloseCircle, "close-circle");
export const CloudIcon = /* @__PURE__ */ createIcon(SvgCloud, "cloud");
export const CloudCheckIcon = /* @__PURE__ */ createIcon(SvgCloudCheck, "cloud-check");
export const CloudDownloadIcon = /* @__PURE__ */ createIcon(SvgCloudDownload, "cloud-download");
export const CloudDownloadBulkIcon = /* @__PURE__ */ createIcon(SvgCloudDownloadBulk, "cloud-download-bulk");
export const CloudDownloadFilledIcon = /* @__PURE__ */ createIcon(SvgCloudDownloadFilled, "cloud-download-filled");
export const CloudServerIcon = /* @__PURE__ */ createIcon(SvgCloudServer, "cloud-server");
export const CloudUploadIcon = /* @__PURE__ */ createIcon(SvgCloudUpload, "cloud-upload");
export const CodeIcon = /* @__PURE__ */ createIcon(SvgApi, "code");
export const CoinsIcon = /* @__PURE__ */ createIcon(SvgCoins, "coins");
export const CollapseIcon = /* @__PURE__ */ createIcon(SvgCollapse, "collapse");
export const CommandIcon = /* @__PURE__ */ createIcon(SvgCommand, "command");
export const CompassIcon = /* @__PURE__ */ createIcon(SvgCompass, "compass");
export const ComputerIcon = /* @__PURE__ */ createIcon(SvgComputer, "computer");
export const ComputerDollarIcon = /* @__PURE__ */ createIcon(SvgComputerDollar, "computer-dollar");
export const ComputerDollarFilledIcon = /* @__PURE__ */ createIcon(SvgComputerDollarFilled, "computer-dollar-filled");
export const ConnectedCableIcon = /* @__PURE__ */ createIcon(SvgConnectedCable, "connected-cable");
export const CopyIcon = /* @__PURE__ */ createIcon(SvgCopy, "copy");
export const CreditCardIcon = /* @__PURE__ */ createIcon(SvgCreditCard, "credit-card");
export const CreditCardEditIcon = /* @__PURE__ */ createIcon(SvgCreditCardEdit, "credit-card-edit");
export const CreditCardFilledIcon = /* @__PURE__ */ createIcon(SvgCreditCardFilled, "credit-card-filled");
export const DashboardIcon = /* @__PURE__ */ createIcon(SvgDashboard, "dashboard");
export const DashboardFilledIcon = /* @__PURE__ */ createIcon(SvgDashboardFilled, "dashboard-filled");
export const DatabaseIcon = /* @__PURE__ */ createIcon(SvgDatabase, "database");
export const DatabaseImportIcon = /* @__PURE__ */ createIcon(SvgDatabaseImport, "database-import");
export const DatabaseImportFilledIcon = /* @__PURE__ */ createIcon(SvgDatabaseImportFilled, "database-import-filled");
export const DeleteIcon = /* @__PURE__ */ createIcon(SvgDelete, "delete");
export const DeliveryIcon = /* @__PURE__ */ createIcon(SvgDelivery, "delivery");
export const DiscountIcon = /* @__PURE__ */ createIcon(SvgDiscount, "discount");
export const DiscoverIcon = /* @__PURE__ */ createIcon(SvgDiscover, "discover", { fill: "currentColor" });
export const DivideIcon = /* @__PURE__ */ createIcon(SvgDivide, "divide");
export const DocumentIcon = /* @__PURE__ */ createIcon(SvgDocument, "document");
export const DocumentAddIcon = /* @__PURE__ */ createIcon(SvgDocumentAdd, "document-add");
export const DocumentAddBulkIcon = /* @__PURE__ */ createIcon(SvgDocumentAddBulk, "document-add-bulk");
export const DocumentAddFilledIcon = /* @__PURE__ */ createIcon(SvgDocumentAddFilled, "document-add-filled");
export const DocumentAttachmentIcon = /* @__PURE__ */ createIcon(SvgAttachment, "document-attachment");
export const DocumentAttachmentFilledIcon = /* @__PURE__ */ createIcon(SvgDocumentAttachmentFilled, "document-attachment-filled");
export const DocumentBulkIcon = /* @__PURE__ */ createIcon(SvgDocumentBulk, "document-bulk");
export const DocumentCheckIcon = /* @__PURE__ */ createIcon(SvgDocumentCheck, "document-check");
export const DocumentClockIcon = /* @__PURE__ */ createIcon(SvgDocumentClock, "document-clock");
export const DocumentDownloadIcon = /* @__PURE__ */ createIcon(SvgDocumentDownload, "document-download");
export const DocumentEditIcon = /* @__PURE__ */ createIcon(SvgDocumentEdit, "document-edit");
export const DocumentEditBulkIcon = /* @__PURE__ */ createIcon(SvgDocumentEditBulk, "document-edit-bulk");
export const DocumentEditFilledIcon = /* @__PURE__ */ createIcon(SvgDocumentEditFilled, "document-edit-filled");
export const DocumentExportIcon = /* @__PURE__ */ createIcon(SvgDocumentDownload, "document-export");
export const DocumentFilledIcon = /* @__PURE__ */ createIcon(SvgDocumentFilled, "document-filled");
export const DocumentPdfIcon = /* @__PURE__ */ createIcon(SvgDocumentPdf, "document-pdf");
export const DocumentRemoveIcon = /* @__PURE__ */ createIcon(SvgDocumentRemove, "document-remove");
export const DocumentTextIcon = /* @__PURE__ */ createIcon(SvgDocumentText, "document-text");
export const DocumentUploadIcon = /* @__PURE__ */ createIcon(SvgDocumentUpload, "document-upload");
export const DocumentZipIcon = /* @__PURE__ */ createIcon(SvgDocumentZip, "document-zip");
export const DogIcon = /* @__PURE__ */ createIcon(SvgDog, "dog");
export const DollarIcon = /* @__PURE__ */ createIcon(SvgDollar, "dollar");
export const DollarCircleIcon = /* @__PURE__ */ createIcon(SvgDollarCircle, "dollar-circle");
export const DollarSquareIcon = /* @__PURE__ */ createIcon(SvgDollarSquare, "dollar-square");
export const DollarUpIcon = /* @__PURE__ */ createIcon(SvgDollarUp, "dollar-up");
export const DollarUpBulkIcon = /* @__PURE__ */ createIcon(SvgDollarUpBulk, "dollar-up-bulk");
export const DollarUpFilledIcon = /* @__PURE__ */ createIcon(SvgDollarUpFilled, "dollar-up-filled");
export const DoorIcon = /* @__PURE__ */ createIcon(SvgDoor, "door");
export const DoorOpenIcon = /* @__PURE__ */ createIcon(SvgDoorOpen, "door-open");
export const DownloadIcon = /* @__PURE__ */ createIcon(SvgDownload, "download");
export const DownloadFilledIcon = /* @__PURE__ */ createIcon(SvgDownloadFilled, "download-filled");
export const DragVerticalIcon = /* @__PURE__ */ createIcon(SvgDragVertical, "drag-vertical");
export const DropletIcon = /* @__PURE__ */ createIcon(SvgDroplet, "droplet");
export const EditIcon = /* @__PURE__ */ createIcon(SvgEdit, "edit");
export const EditSquareIcon = /* @__PURE__ */ createIcon(SvgEditSquare, "edit-square");
export const ExpandIcon = /* @__PURE__ */ createIcon(SvgExpand, "expand");
export const ExternalLinkIcon = /* @__PURE__ */ createIcon(SvgExternalLink, "external-link");
export const EyeIcon = /* @__PURE__ */ createIcon(SvgEye, "eye");
export const EyeOffIcon = /* @__PURE__ */ createIcon(SvgEyeOff, "eye-off");
export const FaceIdLockIcon = /* @__PURE__ */ createIcon(SvgFaceIdLock, "face-id-lock");
export const FaceIdLockBulkIcon = /* @__PURE__ */ createIcon(SvgFaceIdLockBulk, "face-id-lock-bulk");
export const FaceIdLockFilledIcon = /* @__PURE__ */ createIcon(SvgFaceIdLockFilled, "face-id-lock-filled");
export const FilterIcon = /* @__PURE__ */ createIcon(SvgFilter, "filter");
export const FilterClearIcon = /* @__PURE__ */ createIcon(SvgFilterClear, "filter-clear");
export const FingerprintIcon = /* @__PURE__ */ createIcon(SvgFingerprint, "fingerprint");
export const FingerprintFilledIcon = /* @__PURE__ */ createIcon(SvgFingerprintFilled, "fingerprint-filled");
export const FlashIcon = /* @__PURE__ */ createIcon(SvgFlash, "flash");
export const FolderIcon = /* @__PURE__ */ createIcon(SvgFolder, "folder");
export const FolderAddIcon = /* @__PURE__ */ createIcon(SvgFolderAdd, "folder-add");
export const FolderBlockedIcon = /* @__PURE__ */ createIcon(SvgFolderBlocked, "folder-blocked");
export const FolderFilledIcon = /* @__PURE__ */ createIcon(SvgFolderFilled, "folder-filled");
export const FolderLibraryIcon = /* @__PURE__ */ createIcon(SvgFolderLibrary, "folder-library");
export const FolderLibraryFilledIcon = /* @__PURE__ */ createIcon(SvgFolderLibraryFilled, "folder-library-filled");
export const FolderLockIcon = /* @__PURE__ */ createIcon(SvgFolderLock, "folder-lock");
export const FolderOpenIcon = /* @__PURE__ */ createIcon(SvgFolderOpen, "folder-open");
export const FolderTransferIcon = /* @__PURE__ */ createIcon(SvgFolderTransfer, "folder-transfer");
export const FullscreenIcon = /* @__PURE__ */ createIcon(SvgFullscreen, "fullscreen");
export const FullscreenExitIcon = /* @__PURE__ */ createIcon(SvgFullscreenExit, "fullscreen-exit");
export const GiftIcon = /* @__PURE__ */ createIcon(SvgGift, "gift");
export const GlobeIcon = /* @__PURE__ */ createIcon(SvgGlobe, "globe");
export const GlobeFilledIcon = /* @__PURE__ */ createIcon(SvgGlobeFilled, "globe-filled");
export const GridIcon = /* @__PURE__ */ createIcon(SvgGrid, "grid");
export const HashtagIcon = /* @__PURE__ */ createIcon(SvgHashtag, "hashtag");
export const HelpCircleIcon = /* @__PURE__ */ createIcon(SvgHelpCircle, "help-circle");
export const HistoryIcon = /* @__PURE__ */ createIcon(SvgHistory, "history");
export const HomeIcon = /* @__PURE__ */ createIcon(SvgHome, "home");
export const HomeBulkIcon = /* @__PURE__ */ createIcon(SvgHomeBulk, "home-bulk");
export const HomeFilledIcon = /* @__PURE__ */ createIcon(SvgHomeFilled, "home-filled");
export const HomeFunIcon = /* @__PURE__ */ createIcon(SvgHomeFun, "home-fun");
export const HomeFunBulkIcon = /* @__PURE__ */ createIcon(SvgHomeFunBulk, "home-fun-bulk");
export const HomeFunFilledIcon = /* @__PURE__ */ createIcon(SvgHomeFunFilled, "home-fun-filled");
export const HomeSearchIcon = /* @__PURE__ */ createIcon(SvgHomeSearch, "home-search");
export const IdeaIcon = /* @__PURE__ */ createIcon(SvgIdea, "idea");
export const ImageIcon = /* @__PURE__ */ createIcon(SvgImage, "image");
export const ImageMissingIcon = /* @__PURE__ */ createIcon(SvgImageMissing, "image-missing");
export const InboxIcon = /* @__PURE__ */ createIcon(SvgInbox, "inbox");
export const InboxFilledIcon = /* @__PURE__ */ createIcon(SvgInboxFilled, "inbox-filled");
export const InfoCircleIcon = /* @__PURE__ */ createIcon(SvgInfoCircle, "info-circle");
export const InvoiceIcon = /* @__PURE__ */ createIcon(SvgInvoice, "invoice");
export const KeyIcon = /* @__PURE__ */ createIcon(SvgKey, "key");
export const KeyFilledIcon = /* @__PURE__ */ createIcon(SvgKeyFilled, "key-filled");
export const LayersIcon = /* @__PURE__ */ createIcon(SvgLayersAdd, "layers");
export const LayersAddIcon = /* @__PURE__ */ createIcon(SvgLayersAdd, "layers-add");
export const LegalHammerIcon = /* @__PURE__ */ createIcon(SvgLegalHammer, "legal-hammer");
export const LicenseIcon = /* @__PURE__ */ createIcon(SvgAgreement, "license");
export const LinkIcon = /* @__PURE__ */ createIcon(SvgLink, "link");
export const LinkAddIcon = /* @__PURE__ */ createIcon(SvgLink, "link-add");
export const ListIcon = /* @__PURE__ */ createIcon(SvgList, "list");
export const ListBulletIcon = /* @__PURE__ */ createIcon(SvgListBullet, "list-bullet");
export const ListNumberIcon = /* @__PURE__ */ createIcon(SvgListNumber, "list-number");
export const LoadingIcon = /* @__PURE__ */ createIcon(SvgLoading, "loading");
export const LocationIcon = /* @__PURE__ */ createIcon(SvgLocation, "location");
export const LockIcon = /* @__PURE__ */ createIcon(SvgLock, "lock");
export const LockSquareIcon = /* @__PURE__ */ createIcon(SvgLockSquare, "lock-square");
export const LogoutIcon = /* @__PURE__ */ createIcon(SvgLogout, "logout");
export const MagicSelectionIcon = /* @__PURE__ */ createIcon(SvgMagicSelection, "magic-selection");
export const MagicWandIcon = /* @__PURE__ */ createIcon(SvgMagicWand, "magic-wand");
export const MailIcon = /* @__PURE__ */ createIcon(SvgMail, "mail");
export const MailAccountIcon = /* @__PURE__ */ createIcon(SvgMailAccount, "mail-account");
export const MailAccountFilledIcon = /* @__PURE__ */ createIcon(SvgMailAccountFilled, "mail-account-filled");
export const MailAiIcon = /* @__PURE__ */ createIcon(SvgMailAi, "mail-ai");
export const MailBulkIcon = /* @__PURE__ */ createIcon(SvgMailBulk, "mail-bulk");
export const MailCheckIcon = /* @__PURE__ */ createIcon(SvgMailCheck, "mail-check");
export const MailCloseIcon = /* @__PURE__ */ createIcon(SvgMailClose, "mail-close");
export const MailDocumentIcon = /* @__PURE__ */ createIcon(SvgMailDocument, "mail-document");
export const MailDocumentFilledIcon = /* @__PURE__ */ createIcon(SvgMailDocumentFilled, "mail-document-filled");
export const MailEditIcon = /* @__PURE__ */ createIcon(SvgMailEdit, "mail-edit");
export const MailFilledIcon = /* @__PURE__ */ createIcon(SvgMailFilled, "mail-filled");
export const MailOpenIcon = /* @__PURE__ */ createIcon(SvgMailOpen, "mail-open");
export const MailOpenBulkIcon = /* @__PURE__ */ createIcon(SvgMailOpenBulk, "mail-open-bulk");
export const MailOpenFilledIcon = /* @__PURE__ */ createIcon(SvgMailOpenFilled, "mail-open-filled");
export const MailReceiveIcon = /* @__PURE__ */ createIcon(SvgMailReceive, "mail-receive");
export const MailReceiveBulkIcon = /* @__PURE__ */ createIcon(SvgMailReceiveBulk, "mail-receive-bulk");
export const MailReceiveFilledIcon = /* @__PURE__ */ createIcon(SvgMailReceiveFilled, "mail-receive-filled");
export const MailSendIcon = /* @__PURE__ */ createIcon(SvgMailSend, "mail-send");
export const MailSendBulkIcon = /* @__PURE__ */ createIcon(SvgMailSendBulk, "mail-send-bulk");
export const MailSendFilledIcon = /* @__PURE__ */ createIcon(SvgMailSendFilled, "mail-send-filled");
export const MapIcon = /* @__PURE__ */ createIcon(SvgMap, "map");
export const MastercardIcon = /* @__PURE__ */ createIcon(SvgMastercard, "mastercard", { fill: "currentColor" });
export const MegaphoneIcon = /* @__PURE__ */ createIcon(SvgMegaphone, "megaphone");
export const MegaphoneFilledIcon = /* @__PURE__ */ createIcon(SvgMegaphoneFilled, "megaphone-filled");
export const MenuIcon = /* @__PURE__ */ createIcon(SvgMenu, "menu");
export const MinusIcon = /* @__PURE__ */ createIcon(SvgMinus, "minus");
export const MinusCircleIcon = /* @__PURE__ */ createIcon(SvgMinusCircle, "minus-circle");
export const MobileIcon = /* @__PURE__ */ createIcon(SvgMobileCode, "mobile");
export const MobileCodeIcon = /* @__PURE__ */ createIcon(SvgMobileCode, "mobile-code");
export const MobileSendIcon = /* @__PURE__ */ createIcon(SvgDocumentUpload, "mobile-send");
export const MoneyIcon = /* @__PURE__ */ createIcon(SvgMoney, "money");
export const MoneyBagIcon = /* @__PURE__ */ createIcon(SvgMoneyBag, "money-bag");
export const MoneyExchangeIcon = /* @__PURE__ */ createIcon(SvgMoneyExchange, "money-exchange");
export const MoneyExchangeFilledIcon = /* @__PURE__ */ createIcon(SvgMoneyExchangeFilled, "money-exchange-filled");
export const MoneyFilledIcon = /* @__PURE__ */ createIcon(SvgMoneyFilled, "money-filled");
export const MoneyReceiveIcon = /* @__PURE__ */ createIcon(SvgMoneyReceive, "money-receive");
export const MoneySendIcon = /* @__PURE__ */ createIcon(SvgMoneySend, "money-send");
export const MoneySendCircleIcon = /* @__PURE__ */ createIcon(SvgMoneySendCircle, "money-send-circle");
export const MoonIcon = /* @__PURE__ */ createIcon(SvgMoon, "moon");
export const MoreHorizontalIcon = /* @__PURE__ */ createIcon(SvgMoreHorizontal, "more-horizontal");
export const MoreHorizontalCircleIcon = /* @__PURE__ */ createIcon(SvgMoreHorizontalCircle, "more-horizontal-circle");
export const MoreVerticalIcon = /* @__PURE__ */ createIcon(SvgMoreVertical, "more-vertical");
export const MusicNoteIcon = /* @__PURE__ */ createIcon(SvgMusicNote, "music-note");
export const NetworkEditIcon = /* @__PURE__ */ createIcon(SvgNetworkEdit, "network-edit");
export const NoteIcon = /* @__PURE__ */ createIcon(SvgNote, "note");
export const NoteFilledIcon = /* @__PURE__ */ createIcon(SvgNoteFilled, "note-filled");
export const NotificationIcon = /* @__PURE__ */ createIcon(SvgNotification, "notification");
export const NotificationBulkIcon = /* @__PURE__ */ createIcon(SvgNotificationBulk, "notification-bulk");
export const NotificationFilledIcon = /* @__PURE__ */ createIcon(SvgNotificationFilled, "notification-filled");
export const NotificationOffIcon = /* @__PURE__ */ createIcon(SvgNotificationOff, "notification-off");
export const OfficeIcon = /* @__PURE__ */ createIcon(SvgBuilding, "office");
export const OfficeFilledIcon = /* @__PURE__ */ createIcon(SvgBuildingFilled, "office-filled");
export const PackageIcon = /* @__PURE__ */ createIcon(SvgPackage, "package");
export const PaintBrushIcon = /* @__PURE__ */ createIcon(SvgPaintBrush, "paint-brush");
export const PaletteIcon = /* @__PURE__ */ createIcon(SvgPalette, "palette");
export const PaperCurvedIcon = /* @__PURE__ */ createIcon(SvgPaperCurved, "paper-curved");
export const PaperCurvedBulkIcon = /* @__PURE__ */ createIcon(SvgPaperCurvedBulk, "paper-curved-bulk");
export const PaperCurvedFilledIcon = /* @__PURE__ */ createIcon(SvgPaperCurvedFilled, "paper-curved-filled");
export const ParkingIcon = /* @__PURE__ */ createIcon(SvgParking, "parking");
export const PasswordIcon = /* @__PURE__ */ createIcon(SvgPassword, "password");
export const PauseCircleIcon = /* @__PURE__ */ createIcon(SvgPauseCircle, "pause-circle");
export const PaymentIcon = /* @__PURE__ */ createIcon(SvgPayment, "payment");
export const PlayIcon = /* @__PURE__ */ createIcon(SvgPlay, "play");
export const PlayCircleIcon = /* @__PURE__ */ createIcon(SvgPlayCircle, "play-circle");
export const PlugIcon = /* @__PURE__ */ createIcon(SvgPlug, "plug");
export const PlugFilledIcon = /* @__PURE__ */ createIcon(SvgPlugFilled, "plug-filled");
export const PlusIcon = /* @__PURE__ */ createIcon(SvgPlus, "plus");
export const PlusCircleIcon = /* @__PURE__ */ createIcon(SvgPlusCircle, "plus-circle");
export const PrinterIcon = /* @__PURE__ */ createIcon(SvgPrinter, "printer");
export const PushpinIcon = /* @__PURE__ */ createIcon(SvgPushpin, "pushpin");
export const PushpinFilledIcon = /* @__PURE__ */ createIcon(SvgPushpinFilled, "pushpin-filled");
export const QuickbooksIcon = /* @__PURE__ */ createIcon(SvgQuickbooks, "quickbooks", { fill: "currentColor" });
export const ReceiptIcon = /* @__PURE__ */ createIcon(SvgInvoice, "receipt");
export const ReceiptDollarIcon = /* @__PURE__ */ createIcon(SvgComputerDollar, "receipt-dollar");
export const ReceiptDollarFilledIcon = /* @__PURE__ */ createIcon(SvgComputerDollarFilled, "receipt-dollar-filled");
export const ReceiptFilledIcon = /* @__PURE__ */ createIcon(SvgReceiptFilled, "receipt-filled");
export const ReceiptSuccessIcon = /* @__PURE__ */ createIcon(SvgReceiptSuccess, "receipt-success");
export const RedoIcon = /* @__PURE__ */ createIcon(SvgRedo, "redo");
export const RefreshIcon = /* @__PURE__ */ createIcon(SvgRefresh, "refresh");
export const RefreshFilledIcon = /* @__PURE__ */ createIcon(SvgRefreshFilled, "refresh-filled");
export const RepeatIcon = /* @__PURE__ */ createIcon(SvgRepeat, "repeat");
export const RepeatBulkIcon = /* @__PURE__ */ createIcon(SvgRepeatBulk, "repeat-bulk");
export const RepeatFilledIcon = /* @__PURE__ */ createIcon(SvgRepeatFilled, "repeat-filled");
export const ReportsAnalysisIcon = /* @__PURE__ */ createIcon(SvgAnalytics, "reports-analysis");
export const RingtoneIcon = /* @__PURE__ */ createIcon(SvgRingtone, "ringtone");
export const RocketIcon = /* @__PURE__ */ createIcon(SvgRocket, "rocket");
export const RotateClockwiseIcon = /* @__PURE__ */ createIcon(SvgRefresh, "rotate-clockwise");
export const RulerIcon = /* @__PURE__ */ createIcon(SvgRuler, "ruler");
export const SafeIcon = /* @__PURE__ */ createIcon(SvgSafe, "safe");
export const SaveIcon = /* @__PURE__ */ createIcon(SvgSave, "save");
export const SavingsIcon = /* @__PURE__ */ createIcon(SvgSavings, "savings");
export const ScissorsIcon = /* @__PURE__ */ createIcon(SvgScissors, "scissors");
export const SearchIcon = /* @__PURE__ */ createIcon(SvgSearch, "search");
export const SearchListIcon = /* @__PURE__ */ createIcon(SvgSearchList, "search-list");
export const SendIcon = /* @__PURE__ */ createIcon(SvgSend, "send");
export const SendFilledIcon = /* @__PURE__ */ createIcon(SvgSendFilled, "send-filled");
export const SettingsIcon = /* @__PURE__ */ createIcon(SvgSettings, "settings");
export const SettingsFilledIcon = /* @__PURE__ */ createIcon(SvgSettingsFilled, "settings-filled");
export const SettingsGearIcon = /* @__PURE__ */ createIcon(SvgSettingsGear, "settings-gear");
export const SettingsGearBulkIcon = /* @__PURE__ */ createIcon(SvgSettingsGearBulk, "settings-gear-bulk");
export const SettingsGearFilledIcon = /* @__PURE__ */ createIcon(SvgSettingsGearFilled, "settings-gear-filled");
export const ShareIcon = /* @__PURE__ */ createIcon(SvgShare, "share");
export const ShieldIcon = /* @__PURE__ */ createIcon(SvgShield, "shield");
export const ShieldAddIcon = /* @__PURE__ */ createIcon(SvgShieldAdd, "shield-add");
export const ShieldBlockedIcon = /* @__PURE__ */ createIcon(SvgShieldBlocked, "shield-blocked");
export const ShieldCheckIcon = /* @__PURE__ */ createIcon(SvgShieldCheck, "shield-check");
export const ShieldCheckFilledIcon = /* @__PURE__ */ createIcon(SvgShieldCheckFilled, "shield-check-filled");
export const ShieldDoneIcon = /* @__PURE__ */ createIcon(SvgShieldDone, "shield-done");
export const ShieldDoneBulkIcon = /* @__PURE__ */ createIcon(SvgShieldDoneBulk, "shield-done-bulk");
export const ShieldDoneFilledIcon = /* @__PURE__ */ createIcon(SvgShieldDoneFilled, "shield-done-filled");
export const ShieldUserIcon = /* @__PURE__ */ createIcon(SvgShieldUser, "shield-user");
export const ShieldUserBulkIcon = /* @__PURE__ */ createIcon(SvgShieldUserBulk, "shield-user-bulk");
export const ShieldUserFilledIcon = /* @__PURE__ */ createIcon(SvgShieldUserFilled, "shield-user-filled");
export const ShieldWarningIcon = /* @__PURE__ */ createIcon(SvgShieldWarning, "shield-warning");
export const SidebarAgreementIcon = /* @__PURE__ */ createIcon(SvgSidebarAgreement, "sidebar-agreement");
export const SidebarBuildingIcon = /* @__PURE__ */ createIcon(SvgSidebarBuilding, "sidebar-building");
export const SidebarCalendarIcon = /* @__PURE__ */ createIcon(SvgSidebarCalendar, "sidebar-calendar");
export const SidebarChartIcon = /* @__PURE__ */ createIcon(SvgSidebarChart, "sidebar-chart");
export const SidebarClockIcon = /* @__PURE__ */ createIcon(SvgSidebarClock, "sidebar-clock");
export const SidebarDocumentIcon = /* @__PURE__ */ createIcon(SvgSidebarDocument, "sidebar-document");
export const SidebarHistoryIcon = /* @__PURE__ */ createIcon(SvgSidebarHistory, "sidebar-history");
export const SidebarHomeIcon = /* @__PURE__ */ createIcon(SvgSidebarHome, "sidebar-home");
export const SidebarInboxIcon = /* @__PURE__ */ createIcon(SvgSidebarInbox, "sidebar-inbox");
export const SidebarLeftIcon = /* @__PURE__ */ createIcon(SvgSidebarLeft, "sidebar-left");
export const SidebarPeopleIcon = /* @__PURE__ */ createIcon(SvgSidebarPeople, "sidebar-people");
export const SidebarPinIcon = /* @__PURE__ */ createIcon(SvgSidebarPin, "sidebar-pin");
export const SidebarPinFilledIcon = /* @__PURE__ */ createIcon(SvgSidebarPinFilled, "sidebar-pin-filled");
export const SidebarTasksIcon = /* @__PURE__ */ createIcon(SvgSidebarTasks, "sidebar-tasks");
export const SidebarUnitIcon = /* @__PURE__ */ createIcon(SvgSidebarUnit, "sidebar-unit");
export const SidebarUserIcon = /* @__PURE__ */ createIcon(SvgSidebarUser, "sidebar-user");
export const SidebarUserActiveIcon = /* @__PURE__ */ createIcon(SvgSidebarUserActive, "sidebar-user-active");
export const SidebarUserInactiveIcon = /* @__PURE__ */ createIcon(SvgSidebarUserInactive, "sidebar-user-inactive");
export const SidebarVendorIcon = /* @__PURE__ */ createIcon(SvgSidebarVendor, "sidebar-vendor");
export const SidebarViewsIcon = /* @__PURE__ */ createIcon(SvgSidebarViews, "sidebar-views");
export const SidebarWalletIcon = /* @__PURE__ */ createIcon(SvgSidebarWallet, "sidebar-wallet");
export const SidebarWorkIcon = /* @__PURE__ */ createIcon(SvgSidebarWork, "sidebar-work");
export const SignatureIcon = /* @__PURE__ */ createIcon(SvgSignature, "signature");
export const SortIcon = /* @__PURE__ */ createIcon(SvgSort, "sort");
export const SortDownIcon = /* @__PURE__ */ createIcon(SvgSortDown, "sort-down");
export const SortUpIcon = /* @__PURE__ */ createIcon(SvgSortUp, "sort-up");
export const SparklesIcon = /* @__PURE__ */ createIcon(SvgSparkles, "sparkles");
export const StarIcon = /* @__PURE__ */ createIcon(SvgStar, "star");
export const StarFilledIcon = /* @__PURE__ */ createIcon(SvgStarFilled, "star-filled");
export const StarMagicGlowIcon = /* @__PURE__ */ createIcon(SvgStarMagicGlow, "star-magic-glow");
export const StarMagicGlowFilledIcon = /* @__PURE__ */ createIcon(SvgStarMagicGlowFilled, "star-magic-glow-filled");
export const StopIcon = /* @__PURE__ */ createIcon(SvgStop, "stop");
export const StopCircleIcon = /* @__PURE__ */ createIcon(SvgStopCircle, "stop-circle");
export const StopFilledIcon = /* @__PURE__ */ createIcon(SvgStopFilled, "stop-filled");
export const StoreIcon = /* @__PURE__ */ createIcon(SvgStore, "store");
export const StructureIcon = /* @__PURE__ */ createIcon(SvgStructure, "structure");
export const SunIcon = /* @__PURE__ */ createIcon(SvgSun, "sun");
export const SwapHorizontalIcon = /* @__PURE__ */ createIcon(SvgSwapHorizontal, "swap-horizontal");
export const SwapHorizontalFilledIcon = /* @__PURE__ */ createIcon(SvgSwapHorizontalFilled, "swap-horizontal-filled");
export const TableIcon = /* @__PURE__ */ createIcon(SvgTable, "table");
export const TableFilledIcon = /* @__PURE__ */ createIcon(SvgTableFilled, "table-filled");
export const TabletIcon = /* @__PURE__ */ createIcon(SvgTablet, "tablet");
export const TagIcon = /* @__PURE__ */ createIcon(SvgTag, "tag");
export const TargetIcon = /* @__PURE__ */ createIcon(SvgTarget, "target");
export const TargetFilledIcon = /* @__PURE__ */ createIcon(SvgTargetFilled, "target-filled");
export const TargetSearchIcon = /* @__PURE__ */ createIcon(SvgTargetSearch, "target-search");
export const TargetSearchBulkIcon = /* @__PURE__ */ createIcon(SvgTargetSearchBulk, "target-search-bulk");
export const TargetSearchFilledIcon = /* @__PURE__ */ createIcon(SvgTargetSearchFilled, "target-search-filled");
export const TaskIcon = /* @__PURE__ */ createIcon(SvgCheckList, "task");
export const TaskAddIcon = /* @__PURE__ */ createIcon(SvgTaskAdd, "task-add");
export const TaskBulkIcon = /* @__PURE__ */ createIcon(SvgTaskBulk, "task-bulk");
export const TaskCheckIcon = /* @__PURE__ */ createIcon(SvgTaskCheck, "task-check");
export const TaskEditIcon = /* @__PURE__ */ createIcon(SvgDocumentEdit, "task-edit");
export const TaskFilledIcon = /* @__PURE__ */ createIcon(SvgTaskFilled, "task-filled");
export const TaskListIcon = /* @__PURE__ */ createIcon(SvgTaskList, "task-list");
export const TaxesIcon = /* @__PURE__ */ createIcon(SvgComputerDollar, "taxes");
export const TelephoneIcon = /* @__PURE__ */ createIcon(SvgTelephone, "telephone");
export const TextAlignLeftIcon = /* @__PURE__ */ createIcon(SvgTextAlignLeft, "text-align-left");
export const TextBoldIcon = /* @__PURE__ */ createIcon(SvgTextBold, "text-bold");
export const TextItalicIcon = /* @__PURE__ */ createIcon(SvgTextItalic, "text-italic");
export const ThumbDownIcon = /* @__PURE__ */ createIcon(SvgThumbDown, "thumb-down");
export const ThumbUpIcon = /* @__PURE__ */ createIcon(SvgThumbUp, "thumb-up");
export const ToolsIcon = /* @__PURE__ */ createIcon(SvgTools, "tools");
export const UndoIcon = /* @__PURE__ */ createIcon(SvgUndo, "undo");
export const UploadIcon = /* @__PURE__ */ createIcon(SvgUpload, "upload");
export const UserIcon = /* @__PURE__ */ createIcon(SvgUser, "user");
export const UserAddIcon = /* @__PURE__ */ createIcon(SvgUserAdd, "user-add");
export const UserBlockedIcon = /* @__PURE__ */ createIcon(SvgUserBlocked, "user-blocked");
export const UserCheckIcon = /* @__PURE__ */ createIcon(SvgUserCheck, "user-check");
export const UserCircleIcon = /* @__PURE__ */ createIcon(SvgUserCircle, "user-circle");
export const UserDollarIcon = /* @__PURE__ */ createIcon(SvgComputerDollar, "user-dollar");
export const UserEditIcon = /* @__PURE__ */ createIcon(SvgUserEdit, "user-edit");
export const UserEditBulkIcon = /* @__PURE__ */ createIcon(SvgUserEditBulk, "user-edit-bulk");
export const UserEditFilledIcon = /* @__PURE__ */ createIcon(SvgUserEditFilled, "user-edit-filled");
export const UserFilledIcon = /* @__PURE__ */ createIcon(SvgUserFilled, "user-filled");
export const UserIdIcon = /* @__PURE__ */ createIcon(SvgUserId, "user-id");
export const UserSearchIcon = /* @__PURE__ */ createIcon(SvgUserSearch, "user-search");
export const UserSettingsIcon = /* @__PURE__ */ createIcon(SvgUserSettings, "user-settings");
export const UserSettingsBulkIcon = /* @__PURE__ */ createIcon(SvgUserSettingsBulk, "user-settings-bulk");
export const UserSettingsFilledIcon = /* @__PURE__ */ createIcon(SvgUserSettingsFilled, "user-settings-filled");
export const UserVerifyIcon = /* @__PURE__ */ createIcon(SvgUserVerify, "user-verify");
export const UserVerifyBulkIcon = /* @__PURE__ */ createIcon(SvgUserVerifyBulk, "user-verify-bulk");
export const UserVerifyFilledIcon = /* @__PURE__ */ createIcon(SvgUserVerifyFilled, "user-verify-filled");
export const UserWarningIcon = /* @__PURE__ */ createIcon(SvgWarningCircle, "user-warning");
export const UsersIcon = /* @__PURE__ */ createIcon(SvgUsers, "users");
export const UsersFilledIcon = /* @__PURE__ */ createIcon(SvgUsersFilled, "users-filled");
export const UsersGroupIcon = /* @__PURE__ */ createIcon(SvgUsersGroup, "users-group");
export const UsersGroupFilledIcon = /* @__PURE__ */ createIcon(SvgUsersGroupFilled, "users-group-filled");
export const UsersThreeIcon = /* @__PURE__ */ createIcon(SvgUsersThree, "users-three");
export const UsersThreeFilledIcon = /* @__PURE__ */ createIcon(SvgUsersThreeFilled, "users-three-filled");
export const UsersTwoIcon = /* @__PURE__ */ createIcon(SvgUsersTwo, "users-two");
export const UsersTwoFilledIcon = /* @__PURE__ */ createIcon(SvgUsersTwoFilled, "users-two-filled");
export const VideoIcon = /* @__PURE__ */ createIcon(SvgVideo, "video");
export const VisaIcon = /* @__PURE__ */ createIcon(SvgVisa, "visa", { fill: "currentColor" });
export const VoiceIcon = /* @__PURE__ */ createIcon(SvgVoice, "voice");
export const VolumeIcon = /* @__PURE__ */ createIcon(SvgVolume, "volume");
export const WalletIcon = /* @__PURE__ */ createIcon(SvgWallet, "wallet");
export const WalletMenuIcon = /* @__PURE__ */ createIcon(SvgWalletMenu, "wallet-menu");
export const WalletMenuBulkIcon = /* @__PURE__ */ createIcon(SvgWalletMenuBulk, "wallet-menu-bulk");
export const WalletMenuFilledIcon = /* @__PURE__ */ createIcon(SvgWalletMenuFilled, "wallet-menu-filled");
export const WarningIcon = /* @__PURE__ */ createIcon(SvgWarning, "warning");
export const WarningCircleIcon = /* @__PURE__ */ createIcon(SvgWarningCircle, "warning-circle");
export const WarningFilledIcon = /* @__PURE__ */ createIcon(SvgWarningFilled, "warning-filled");
export const WebProtectionIcon = /* @__PURE__ */ createIcon(SvgWebProtection, "web-protection");
export const WebProtectionFilledIcon = /* @__PURE__ */ createIcon(SvgWebProtectionFilled, "web-protection-filled");
export const WebhookIcon = /* @__PURE__ */ createIcon(SvgWebhook, "webhook");
export const WorkflowIcon = /* @__PURE__ */ createIcon(SvgStructure, "workflow");
export const WrenchIcon = /* @__PURE__ */ createIcon(SvgWrench, "wrench");
export const WrenchFilledIcon = /* @__PURE__ */ createIcon(SvgWrenchFilled, "wrench-filled");
export const ZillowIcon = /* @__PURE__ */ createIcon(SvgZillow, "zillow", { fill: "currentColor" });
export const ZoomInIcon = /* @__PURE__ */ createIcon(SvgZoomIn, "zoom-in");
export const ZoomOutIcon = /* @__PURE__ */ createIcon(SvgZoomOut, "zoom-out");
